import React from 'react'
import CustomImage from '../customImage/customImage'
import type { IStream } from '../../api/dto/IStream'
import { IEventWithStream } from '../../App'
import { ArrowRight } from '../../assets/icons/arrowRight'

interface IProps {
    item: IStream
    currentEvent: IEventWithStream | null
    className?: string
    onClick: () => void
}

const ChannelsItem = ({ item, currentEvent, className, onClick }: IProps) => {
    const isActiveChannel = currentEvent?.stream?.[0]?.uuid === item.uuid
    return (
        <div
            title={item.name}
            onClick={onClick}
            className={`${className} min-h-[50px] mb-[10px] rounded-lg hover:bg-darkBlueOpacity1 ${isActiveChannel ? 'bg-darkBlueOpacity1' : ''} relative flex justify-between items-center cursor-pointer h-[50px] overflow-hidden px-[10px] border-b-2 border-darkBlueOpacity0`}
        >
            <div className="flex items-center max-w-[210px]">
                <CustomImage
                    width={24}
                    height={24}
                    className="w-[24px] min-w-[24px] min-h-[24px] h-[24px]"
                    mockImg="/images/mockLogos/noTeam.svg"
                    src={item.icon}
                    alt={item.name}
                />
                <span className="channelName ml-[20px] text-white text-[16px] font-poppinsRegular whitespace-nowrap unique:max-w-[120px] header:max-w-[180px] overflow-hidden text-ellipsis">
                    {item.name}
                </span>
            </div>
            <div className="text-cyan flex items-center justify-center px-[6px] py-[3px] rounded-[8px]">
                <span
                    className={`text-[14px] font-poppinsBold whitespace-nowrap overflow-hidden text-ellipsis text-${isActiveChannel ? 'white' : 'cyan'}`}
                >
                    {isActiveChannel ? 'Watching' : 'Watch'}
                </span>
                {!isActiveChannel && (
                    <ArrowRight className="ml-[12px] w-[9px] h-[10px] fill-cyan stroke-cyan" />
                )}
            </div>
        </div>
    )
}

export default ChannelsItem
